'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import text from 'I18n/utils/unescapedText';
import ColorPicker from 'ContentComponents/cmv2/fields/ColorPicker';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { COLOR } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import ToolFormLabel from 'DesignComponents/tool/ToolFormLabel';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import UIToggle from 'UIComponents/input/UIToggle';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { makeGetIsEmailOrAnyType } from 'DesignData/selectors/customWidgetBuffers';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import { SHOW_OPACITY } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { OPACITY_DEFAULT } from 'ContentUtils/constants/Colors';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class ColorContentOptions extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = color => {
      this.props.editField({
        [DEFAULT]: color
      });
    };

    this.onShowOpacityChange = e => {
      const {
        field,
        editField
      } = this.props;
      const checked = e.target.checked;
      const updatedField = {
        [SHOW_OPACITY]: checked
      };

      if (!checked) {
        updatedField[DEFAULT] = this.resetColorOpacity(field);
      }

      editField(updatedField);
    };

    this.onOverrideOpacityChange = e => {
      const {
        field,
        isEmailOrAnyType,
        editField
      } = this.props;
      const checked = e.target.checked;
      const updatedField = {
        [SHOW_OPACITY]: checked ? !isEmailOrAnyType : undefined
      }; //if hiding opacity, reset value so uneditable custom value is not saved

      if (isEmailOrAnyType) {
        updatedField[DEFAULT] = this.resetColorOpacity(field);
      }

      editField(updatedField);
    };
  }

  resetColorOpacity(field) {
    //if hiding opacity, reset value so uneditable custom value is not saved
    return Object.assign({}, field.default, {
      opacity: OPACITY_DEFAULT
    });
  }

  renderShowOpacityToggle() {
    const {
      field,
      readOnly
    } = this.props;
    const shouldOverrideOpacity = field[SHOW_OPACITY] !== undefined;
    return /*#__PURE__*/_jsxs("div", {
      className: "m-top-3",
      children: [/*#__PURE__*/_jsx(UICheckbox, {
        checked: shouldOverrideOpacity,
        description: /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('color.overrideOpacityHelp')
          })
        }),
        descriptionLayout: "horizontal",
        onChange: this.onOverrideOpacityChange,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('color.overrideOpacity')
        })
      }), shouldOverrideOpacity && /*#__PURE__*/_jsxs("div", {
        className: "m-top-3",
        children: [/*#__PURE__*/_jsx(ToolFormLabel, {
          className: "p-right-4 p-top-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('color.showOpacity')
          })
        }), /*#__PURE__*/_jsx(SidebarInput, {
          checked: field[SHOW_OPACITY],
          disabled: readOnly,
          inputComponent: UIToggle,
          onChange: this.onShowOpacityChange,
          required: true,
          size: "extra-small"
        })]
      })]
    });
  }

  render() {
    const {
      field,
      fieldErrors,
      readOnly,
      isEmailOrAnyType
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "custom-widget-editor-color-picker",
      children: /*#__PURE__*/_jsxs(ToolFieldset, {
        children: [/*#__PURE__*/_jsx(FormControlWithErrors, {
          errors: fieldErrors[DEFAULT],
          label: text(i18nKey(`defaultLabels.${COLOR}`)),
          children: /*#__PURE__*/_jsx(ColorPicker, {
            onFieldChange: this.onDefaultChange,
            value: field[DEFAULT],
            readOnly: readOnly,
            isEmailOrAnyType: isEmailOrAnyType,
            show_opacity: field[SHOW_OPACITY]
          })
        }), this.renderShowOpacityToggle()]
      })
    });
  }

}

ColorContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object,
  readOnly: PropTypes.bool,
  isEmailOrAnyType: PropTypes.bool
};

function makeMapStateToProps() {
  const getIsEmailOrAnyType = makeGetIsEmailOrAnyType();
  return (state, props) => {
    return {
      isEmailOrAnyType: getIsEmailOrAnyType(state, props)
    };
  };
}

export default connect(makeMapStateToProps, null)(ColorContentOptions);